// Shared formatting. A rate is never rendered without the volume behind it —
// the PRD is explicit that a rate seen alone will be misread.
export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 1) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const money = (v, currency) =>
  v == null ? '—' : `${currency === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN')}`;

export const CLASS_LABEL = { branded: 'Branded', competitor: 'Competitor', generic: 'Generic' };
